import React from 'react';
import { useDispatch } from 'react-redux';
import { IconButton, Tooltip, useTheme } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { toggleQuickNotesPanel } from './store/stateSlice';

function QuickNotesPanelToggleButton() {
	const dispatch = useDispatch();
	const theme = useTheme();
	const { t } = useSettings();

	return (
		<Tooltip title={t('MY_NOTES_TITLE')} arrow>
			<IconButton /* className="w-40 h-40" */ onClick={() => dispatch(toggleQuickNotesPanel())}>
				<Icon icon="text-box-multiple-outline" color={theme.palette.primary.contrastText} />
			</IconButton>
		</Tooltip>
	);
}

export default QuickNotesPanelToggleButton;
